import { render, staticRenderFns } from "./leistungen-overview.vue?vue&type=template&id=38f7b131&scoped=true"
import script from "./leistungen-overview.vue?vue&type=script&lang=js"
export * from "./leistungen-overview.vue?vue&type=script&lang=js"
import style0 from "./leistungen-overview.vue?vue&type=style&index=0&id=38f7b131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7b131",
  null
  
)

export default component.exports